module.exports = __webpack_public_path__ + "static/img/brimstone.fd82faa5.png";